import type { Option } from 'fp-ts/Option';
import * as O from 'fp-ts/Option';
import { atom } from 'jotai';

import type { User } from '../domain/User';

export const userState = atom<Option<User>>(O.none);
